export default __webpack_public_path__ + "static/media/dnd_equal_icon.adb81760.svg";